module.exports = __webpack_public_path__ + "static/media/ic_peravaunu_a.bca15f87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_peravaunu_a.svg
// module id = 1168
// module chunks = 0